import {
  DATA_ATTRIBUTE_SELECTORS,
  DATA_ATTRIBUTES,
} from '../hooks/richTextArea/constants';

export const hasSignatureBlock = (html: string): boolean =>
  typeof DOMParser !== 'undefined' &&
  html.includes(DATA_ATTRIBUTES.EMAIL_SIGNATURE);

const parseHtmlDocument = (html: string): Document =>
  new DOMParser().parseFromString(html, 'text/html');

export const stripSignatureBlock = (html: string): string => {
  if (!hasSignatureBlock(html)) {
    return html;
  }

  const doc = parseHtmlDocument(html);
  doc
    .querySelectorAll(DATA_ATTRIBUTE_SELECTORS.EMAIL_SIGNATURE)
    .forEach((block) => block.remove());
  return doc.body.innerHTML;
};

export const extractSignatureBlock = (html: string): string => {
  if (!hasSignatureBlock(html)) {
    return '';
  }

  const block = parseHtmlDocument(html).querySelector(
    DATA_ATTRIBUTE_SELECTORS.EMAIL_SIGNATURE,
  );
  return block?.outerHTML ?? '';
};
